import { Events, pubsub } from '@service';
import { BranchLocation, ZipCode } from '@model';
import timeZoneService from '@service/timezone';
import { branchContactLine } from './branch-contact';

export class HeaderBranchLocation extends HTMLElement {
  /** @type {BranchLocation} */
  currentBranch;

  /** @type {HTMLElement} */
  el;

  /** @type {HTMLElement} */
  city;
  /** @type {HTMLElement} */
  state;
  /** @type {HTMLElement} */
  isOpen;
  /** @type {HTMLElement} */
  isClosed;

  constructor() {
    super();
    const container = this.querySelector('.branch-location-info');
    this.el = container;
    this.city = container.querySelector('.city');
    this.state = container.querySelector('.state');
    this.isOpen = container.querySelector('.is-open');
    this.isClosed = container.querySelector('.is-closed');

    this.init().then(() => {});
  }

  update(branchLocation) {
    this.currentBranch = branchLocation;
    this.city.textContent = branchLocation.city;
    this.state.textContent = branchLocation.state;

    document.getElementById('BCS-header-phone').textContent = branchLocation.phone;

    if (document.getElementById('BCS-branch-manager')) {
      document.getElementById('BCS-branch-manager').innerHTML = '<div class="bcs-local"><img src="'+branchLocation.headshot+'" /><strong>Need Assistance?</strong><p>'+branchContactLine(branchLocation)+'</p><a href="tel:'+branchLocation.phone+'" class="secondary-nav__item secondary-nav__cta bg-brand-yellow rounded-[50px] py-4 px-8 text-brand-gray-800"><svg class="icon icon--phone" width="17" height="17" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation"><path stroke="currentColor" d="M11,8.92l-2.75.53A6.82,6.82,0,0,1,4.61,5.79L5.12,3,4.15.46H1.65A1.2,1.2,0,0,0,.42,1.82,13.93,13.93,0,0,0,3.94,9.45a17.1,17.1,0,0,0,8.2,4.08,1.22,1.22,0,0,0,1.47-1.23V9.91Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" transform="translate(1.5 1.5)"></path></svg><span class="secondary-nav__text">'+branchLocation.phone+'</span></a></div>';
    }

    if (!!branchLocation.operatingHours && !!branchLocation.operatingHours.timeZone) {
      const timeZone = branchLocation.operatingHours.timeZone;

      // Create a variable representing opening and closing hours in the branch's time zone
      const [openingHour, closingHour] = timeZoneService.getOperatingHoursForTimeZone(timeZone);

      // Current time in the branch's time zone as a Date instance
      const nowInZone = new Date(new Date().toLocaleString('en-US', { timeZone }));

      const isNormalBusinessHours = nowInZone >= openingHour && nowInZone < closingHour;

      if (isNormalBusinessHours) {
        this.isOpen.classList.remove('hidden');
        this.isClosed.classList.add('hidden');
      } else {
        this.isOpen.classList.add('hidden');
        this.isClosed.classList.remove('hidden');
      }
    }

    this.el.classList.remove('hidden');
  }

  async init() {
    pubsub.subscribe(Events.branchLocationResolved, branchLocation => {
      // Update the branchLocation object to have some time information

      sessionStorage.setItem('branchLocationInformation', JSON.stringify(branchLocation));
      this.update(branchLocation);
    });

    // Try reading the current branch location from storage
    const branchLocationInfo = sessionStorage.getItem('branchLocationInformation');
    if (!!branchLocationInfo) {
      const branchLocation = Object.assign(new BranchLocation(), JSON.parse(branchLocationInfo));
      if (branchLocation.city && branchLocation.state) {
        this.update(branchLocation);
        return;
      }
    }

    // Try reading the current zip code object from storage
    const locationInfo = sessionStorage.getItem('locationInformation');
    if (!!locationInfo) {
      const zipCodeData = Object.assign(new ZipCode(), JSON.parse(locationInfo));
      if (5 === zipCodeData.branchZipCode.length) {
        pubsub.pub(Events.branchZipCodeCollected, zipCodeData.branchZipCode);
      }
    }
  }

  static register() {
    if (!customElements.get('header-branch-location')) {
      customElements.define('header-branch-location', HeaderBranchLocation);
    }
  }
}

HeaderBranchLocation.register();
